import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import * as z from "zod";

import AdminRoutes from "Routes/Components/Admin";

import { HTTPErrorCallback } from "Helpers/Error";
import { cpfCnpjMask } from "Helpers/Format";
import { clearMask } from "Helpers/Util";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

import Button from "Components/Admin/Buttons";
import FormWrapper from "Components/Admin/Form/FormWrapper";
import Input from "Components/Admin/Form/Input";
import Select from "Components/Admin/Form/Select";
import Section from "Components/Admin/Section";

import { organizationTypeOptions } from "../constants";
import * as S from "./styles";

const CreateParticipant = () => {
  const { api } = UseServices();
  const { showNotification } = UseNotification();
  const { loading, setLoading } = UseGlobalLoading();
  const navigate = useNavigate();

  const [cnpj, setCnpj] = useState("");

  const formSchema = z.object({
    name: z.string().min(3, "Nome deve ter ao menos 3 caracteres"),
    email: z.string().email("E-mail inválido").optional().or(z.literal("")),
    phone: z.string().optional().or(z.literal("")),
    website: z.string().optional().or(z.literal("")),
    description: z.string().optional().or(z.literal("")),
    // Dados da organização (opcionais).
    organization_type: z.string().optional().or(z.literal("")).nullable(),
    organization_area: z.string().optional().or(z.literal("")).nullable(),
    address: z.string().optional().or(z.literal("")).nullable(),
    neighbourhood: z.string().optional().or(z.literal("")).nullable(),
    city: z.string().optional().or(z.literal("")).nullable(),
    state: z.string().optional().or(z.literal("")).nullable(),
    cep: z.string().optional().or(z.literal("")).nullable(),
  });

  const methods = useForm({
    resolver: zodResolver(formSchema),
  });
  const { register } = methods;

  const submit = (data) => {
    if (!cnpj || clearMask(cnpj).length !== 14) {
      showNotification("danger", "Atenção!", "Informe um CNPJ válido.");
      return;
    }

    setLoading(true);

    data.cnpj = clearMask(cnpj);
    if (data.phone) data.phone = clearMask(data.phone);

    api
      .post("/participants/create", data)
      .then(() => {
        setLoading(false);
        showNotification(
          "success",
          "Sucesso!",
          "Proponente criado com sucesso!",
        );
        navigate(AdminRoutes.ListParticipants.path);
      })
      .catch((error) => {
        setLoading(false);
        return HTTPErrorCallback(error);
      });
  };

  return (
    <Section>
      <S.Wrapper>
        <FormWrapper submit={submit} {...methods}>
          <Input
            {...register("name")}
            type="text"
            label="Nome da Empresa:"
            placeholder="Razão Social"
            required
          />
          <Input
            name="cnpj"
            type="text"
            label="CNPJ:"
            placeholder="00.000.000/0000-00"
            value={cnpj}
            onChange={(e) => setCnpj(cpfCnpjMask(e.target.value))}
            required
          />
          <Input
            {...register("email")}
            type="email"
            label="E-mail Corporativo:"
            placeholder="contato@empresa.com"
          />
          <Input
            {...register("phone")}
            type="text"
            label="Telefone:"
            placeholder="+55 (00) 00000-0000"
            mask="+99 (99) 99999-9999"
          />
          <Input
            {...register("website")}
            type="text"
            label="Website:"
            placeholder="https://empresa.com.br"
          />
          <Input
            {...register("description")}
            type="text"
            label="Descrição:"
            placeholder="Breve descrição da empresa"
          />
          <Select
            name="organization_type"
            label="Tipo de organização:"
            placeholder="Selecione"
            options={organizationTypeOptions}
          />
          <Input
            {...register("organization_area")}
            type="text"
            label="Ramo de atividade:"
            placeholder="Ramo de atividade da organização"
          />
          <Input
            {...register("cep")}
            type="text"
            label="CEP:"
            placeholder="00000-000"
          />
          <Input
            {...register("address")}
            type="text"
            label="Endereço:"
            placeholder="Logradouro"
          />
          <Input
            {...register("neighbourhood")}
            type="text"
            label="Bairro:"
            placeholder="Bairro"
          />
          <Input
            {...register("city")}
            type="text"
            label="Cidade:"
            placeholder="Cidade"
          />
          <Input
            {...register("state")}
            type="text"
            label="Estado:"
            placeholder="UF"
          />

          <Button
            type="submit"
            text={loading ? "Salvando..." : "Criar Proponente"}
            disabled={loading}
          />
        </FormWrapper>
      </S.Wrapper>
    </Section>
  );
};

export default CreateParticipant;
